import React, { useEffect, useState } from 'react'

import DeckTagService from 'services/deckTag.service'
import { DeckTagListResposne } from 'services/apiTypes/deckTag.types'

import PhatInput from '../PhatInput'
import ArchidektDropdown from 'components/elements/ArchidektDropdown'
import SimpleSpinner from 'components/elements/SimpleSpinner'
import Icon from 'components/elements/Icon'

import styles from './deckTagSelector.module.scss'

type Props = {
  onSelect: (tagId: number, tagName: string) => void
  onChange?: (selectedTagName: string) => void
  placeholder?: string
  disabled?: boolean
  label?: string
  className?: string
  clearValueOnSelection?: boolean
  initalSelectedTagId?: number | null | undefined
  disabledOptions?: Record<string, boolean>
}

const DeckTagSelector = ({
  onSelect,
  onChange,
  placeholder = 'Budget, Elves, cEDH, etc.',
  disabled,
  label,
  className = '',
  clearValueOnSelection = false,
  initalSelectedTagId,
  disabledOptions = {},
}: Props) => {
  const [loading, setLoading] = useState(false)
  const [rawTags, setRawTags] = useState<DeckTagListResposne>()
  const [filter, setFilter] = useState('')

  useEffect(() => {
    setLoading(true)

    DeckTagService.list()
      .then(rawTags => {
        setRawTags(rawTags)

        if (initalSelectedTagId) {
          const initialFilter = rawTags.find(o => `${o.id}` === `${initalSelectedTagId}`)

          if (initialFilter) setFilter(initialFilter?.name)
        }
      })
      .finally(() => setLoading(false))
  }, [])

  const handleSelectTag = (tagId: number, tagName: string) => {
    onSelect(tagId, tagName)

    if (clearValueOnSelection) setFilter('')
    else setFilter(tagName)
  }

  const handleChange = (filterValue: string) => {
    if (onChange) onChange(filterValue)
    setFilter(filterValue)
  }

  const options: { id: any; label: string; onClick: () => void; aliases: string }[] =
    rawTags?.map(tag => ({
      id: tag.id,
      label: tag.name.toLocaleLowerCase(),
      onClick: () => handleSelectTag(tag.id || 0, tag.name),
      aliases: tag.aliases,
      disabled: disabledOptions[tag.name] || false,
    })) || []

  return (
    <div className={`${styles.group} ${className}`}>
      <label>{label || 'Choose tag to add'}</label>
      <ArchidektDropdown
        skipCloseOnClick
        disabled={disabled}
        menuClassName={styles.menu}
        options={
          loading
            ? [
                {
                  type: 'custom',
                  customChild: (
                    <span className={styles.loadingOption}>
                      <SimpleSpinner size="xSmall" /> Loading tags
                    </span>
                  ),
                },
              ]
            : options.filter(
                o =>
                  o.label.toLocaleLowerCase().includes(filter.toLocaleLowerCase()) ||
                  o.aliases.toLocaleLowerCase().includes(filter.toLocaleLowerCase()),
              )
        }>
        <span className={styles.trigger}>
          <PhatInput
            selectOnFocus
            className={styles.input}
            placeholder={loading && initalSelectedTagId ? 'Fetching tags ...' : placeholder}
            onChange={handleChange}
            disabled={disabled || (loading && !!initalSelectedTagId)}
            value={filter}
          />
          <Icon name="triangle down" className={styles.dropdownIndicator} />
        </span>
      </ArchidektDropdown>
    </div>
  )
}

export default DeckTagSelector
